// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-access-description {
  max-height: 90vh;
  height: 680px;
  width: 980px;
}
.dialog-access-description__body {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryDialogues/DialogAccessDescription/DialogAccessDescription.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,YAAA;AACJ;AACI;EACI,aAAA;AACR","sourcesContent":[".dialog-access-description {\n  max-height: 90vh;\n  height: 680px;\n  width: 980px;\n}\n.dialog-access-description__body {\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
